module.exports = __webpack_public_path__ + "static/media/top_banner_2.8fce97e6.png";